import jwtDecode from 'jwt-decode';

export function IsJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export function getTokenData(token) {
  try {
    return jwtDecode(token);
  } catch (e) {
    return {};
  }
}

export function isValidToken(token) {
  try {
    jwtDecode(token);
  } catch (e) {
    return false;
  }

  return true;
}
